var exports = {
  "x": "ClientInfo.module__button___VTBrMj",
};

module.exports = exports;
